import { BaseApi } from './base.api.js';

export class HomeApi extends BaseApi {
    constructor(client) {
        super(client, '/home');
    }

    /**
     * GET /home?sections=a,b — only the requested summary sections are computed.
     * @param {string[]} [sections] empty/omitted → all sections
     */
    async getSummary(sections = []) {
        const params = sections.length > 0 ? { sections: sections.join(',') } : undefined;
        const response = await this.client.get(this.basePath, { params });
        return response.data;
    }
}
